import React, { useRef, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  fetchDistrictFlyersAndSchoolsForSchool,
  fetchDistrictFlyersAndSchools,  
} from '../../screens/Flyers/screens/FlyerGrid/redux'
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Avatar from '@material-ui/core/Avatar';
import { css } from 'emotion'
import { Link } from './Link'
import { matchPath, withRouter } from 'react-router-dom'
const { colors, elements } = require('@peachjar/components')

const {  Paragraph } = elements.typography

const FlyerBoardDropDown = ({ 
  options,
  isAuthenticated,
  fetchDistrictFlyersAndSchools, 
  fetchDistrictFlyersAndSchoolsForSchool,
  history
  }) => {
  const flyerBoardButton = useRef() 
  const pathname = history.location.pathname
  const [open, setOpen] = useState(false)  

  const handleToggle = () => {
    setOpen(!open)
  };

  const handleClose = (event: React.SyntheticEvent<EventTarget>) => {
    // This prevents both handleToggle and handleClose being called on profile button click
    const clickedNode = event.target;
    const flyerBoardButtonRef = flyerBoardButton.current;
    const isNodeChildOfflyerBoardButton =
    flyerBoardButtonRef && flyerBoardButtonRef.contains(clickedNode);

    if (isNodeChildOfflyerBoardButton) {
      return;
    }

    setOpen(false)
  };

  const handleClick = (audienceId, audienceType) => {
    if(audienceType === 'school'){
      fetchDistrictFlyersAndSchoolsForSchool(audienceId)
    }
    else {
      fetchDistrictFlyersAndSchools(audienceId)
    }    
    setOpen(false)
  }

  const getLink = (name, audienceType, audienceId, idx) => {
    const resource = audienceType === 'school' ? 'schools' : 'districts'
    const link = `/flyers/all/${resource}/${audienceId}/${window.location.search}`
    const isActive = matchPath(pathname, {
      path: link,
      exact: true,
    }) || pathname.includes(`${resource}/${audienceId}/`)
    return (
      <Link
        key={idx}
        to={link}
        className={classNames.flyerBoardLink}
        onClick={()=> handleClick(audienceId, audienceType)}
        data-testid={name}
      >
        <li
          className={`${audienceType === 'school' ?  classNames.flyerBoardLinkList : classNames.districtNameLink} ${isActive ? classNames.activeLink : ''}`}
        >
          {name}
        </li>
      </Link>
    )
  }

  return (    
    <Fragment>
      <Button
        ref={flyerBoardButton}
        aria-owns={open ? 'menu-list-grow' : null}
        aria-haspopup="true"
        onClick={handleToggle}
        style={{
          display: 'flex',        
          height: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0px 1rem',
          borderRadius: '0px',
          textTransform: 'none',
          borderBottom: `4px solid ${colors.leaf}`
        }}
        data-testid="flyer-boards-dropdown"
      >
        <div className={classNames.dropdownTriggerContent}>
          <Avatar className={classNames.iconContainer}>          
              <img          
              src='/assets/flyerboard_icon_white.svg'
              alt="Flyer board"
              style={{ width: '16px' }}
            />
          </Avatar>
          <Paragraph className={classNames.flyearBoard}>
            Flyers
          </Paragraph>   
        </div>           
      </Button>
      <Popper
        open={open}
        anchorEl={flyerBoardButton.current}
        transition
        disablePortal
        placement="bottom-end"
        className={classNames.popper}
      >
        {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id="menu-list-grow"
              style={{ transformOrigin: 'center top' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <div className={classNames.flyerBoardContainer}>
                      {options.map(
                        (
                          {
                            districtId,
                            districtName,
                            subscriptions,
                          },
                          index                          
                        ) => (
                          <ul className={classNames.flyerBoardMenu} key={index}>
                            {isAuthenticated &&
                              getLink(districtName, 'district', districtId, districtName)
                            }
                           {subscriptions.map(
                              (
                                {
                                  name,
                                  audienceId,
                                  audienceType
                                },
                                idx
                              ) => getLink(name, audienceType, audienceId, idx)
                            )}
                          </ul>
                        )                                                    
                      )}                      
                    </div>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
      </Popper>
    </Fragment>        
  )
}

const classNames = {
  iconContainer: css`
    && {
      width: 1rem;
      height: 1.5rem;
      background-color: transparent;
    }
  `,  
  flyearBoard: css`
    white-space: nowrap;
    padding: 0 0 0 5px;
    font-size: 13px !important;
  `,
  dropdownTriggerContent: css`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  `,
  popper: css`
   z-index: 999999;
   width: 240px;
 `,
  flyerBoardContainer: css`
    overflow: auto;
    overflow-x: hidden;
    max-height: calc(70vh);
    font-family: 'Proxima Nova', Helvetica, sans-serif ;
  `,
  flyerBoardMenu: css`
    list-style-type: none;
    padding: 8px 4px 15px 4px;
    margin-block-start: 0em;
    margin-block-end: 0em;
    & + ul {
      border-top: 1px solid rgba(0,0,0,.1);            
    }    
  `,
  flyerBoardLinkList: css`
    color: ${colors.prussian};
    padding: 17px 32px;
    height: 54px;
    font-size: 13px;
    border-radius: 3px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    &:hover {
      text-decoration: none;
      background-color: #ededed;
    }
  `,
  flyerBoardLink: css`
    &:hover {
      text-decoration: none;
    }
  `,
  activeLink: css`
    border-left: 4px solid ${colors.leaf};
    font-weight: 700 !important;
    padding-left: 22px;
    background-color: rgba(0, 0, 0, 0.03);
  `,
  districtNameLink: css`
    color: ${colors.prussian};
    padding: 20px 10px 10px 11px;
    font-size: 16px;
    height: 56px;
    border-radius: 3px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    &:hover {
      text-decoration: none;
      background-color: #ededed;
    }
  `
}

const mapDispatchToProps = dispatch => ({
  fetchDistrictFlyersAndSchools: districtId =>
    dispatch(fetchDistrictFlyersAndSchools(districtId)),
  fetchDistrictFlyersAndSchoolsForSchool: schoolId =>
    dispatch(fetchDistrictFlyersAndSchoolsForSchool(schoolId)),  
})

export default connect(null, mapDispatchToProps)(withRouter(FlyerBoardDropDown))



// WEBPACK FOOTER //
// ./src/shared/components/FlyerBoardDropDown.js